/**创建报告 */
<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" >
        <el-form-item label="样品编号">
            <el-input v-model="form.samplesNumber"></el-input>
        </el-form-item>
        <el-form-item label="报告编号">
            <el-input v-model="form.reportNumber"></el-input>
        </el-form-item>
        <el-form-item label="单位">
            <el-input v-model="form.unit"></el-input>
        </el-form-item>
        <el-form-item label="样品名称">
            <el-input v-model="form.projectName"></el-input>
        </el-form-item>
        <el-form-item label="samplesNmae">
            <el-input v-model="form.samplesNmae"></el-input>
        </el-form-item>
        <el-form-item label="型号规格">
            <el-input v-model="form.specification"></el-input>
        </el-form-item>
        <el-form-item label="时间">
            <el-date-picker
            value-format="yyyy/MM/dd"
                v-model="form.date"
                type="date"
                placeholder="选择日期">
            </el-date-picker> 
        </el-form-item>
        <el-form-item label="pdyj">
            <el-input v-model="form.pdyj"></el-input>
        </el-form-item>
        <el-form-item label="jconclusion">
            <el-input v-model="form.jconclusion"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">立即创建</el-button>
            <!-- <el-button>取消</el-button> -->
        </el-form-item>
    </el-form>
</template>

<script>
import {CreateReport} from '../../api/report'
export default {
    data() {
      return {
        form: {
          samplesNumber: '',
          reportNumber: '',
          unit: '',
          projectName: '',
          samplesNmae: '',
          specification: '',
          date: '',
          pdyj: '',
          jconclusion: ''
        },
        // rules表单验证
        rules: {
            samplesNumber: [
            { required: true, message: '请输入名称', trigger: 'blur' }
            ],
            reportNumber: [{ required: true, message: '请输入', trigger: 'blur' }]
        }
      }
    },
    methods: {
      onSubmit(createData) {
        this.$refs[createData].validate(valid => {
        if (valid) {
            CreateReport(this.form)
            .then(res => {
              if (res.code == 0) {
                this.clearForm();
                this.$message({
                  type: 'success',
                  message: '创建成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('创建失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
      },
      clearForm(){
        this.form.samplesNumber = null;
          this.form.reportNumber = null;
          this.form.unit = null;
          this.form.projectName = null;
          this.form.samplesNmae = null;
          this.form.specification = null;
          this.form.date = null;
          this.form.pdyj = null;
          this.form.jconclusion = null;

      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/report/createReport.vue